export const schemeReferralCreateTranslations = {
    en: {
        fetchOpdFailed: "Failed to fetch OPD numbers!",
        fetchSchemesFailed: "Failed to fetch schemes!",
        submitSuccess: "Scheme referred successfully!",
        submitFailed: "Failed to refer scheme!",
        submitting: "Submitting...",
        submit: "Submit",

        beneficiaryInformation: "Beneficiary Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No eg. 00005",
        beneficiaryName: "Beneficiary Name",
        date: "Date",

        selectSchemes: "Select Schemes",
        schemes: "Schemes",

        noSchemeName: "No scheme name",
        noDescription: "No description available",
        requireDoc: "Require Doc",
        noRequireDoc: "No required documents available",
        eligibility: "Eligibility",
        noEligibility: "No eligibility criteria available",
        coveredDiseases: "Covered Diseases",
        noDiseasesListed: "No diseases listed",

        remarks: "Remarks",
        remark: "Remark"
    },
    mr: {
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
        fetchSchemesFailed: "योजना आणण्यात अयशस्वी!",
        submitSuccess: "योजना यशस्वीरित्या संदर्भित केली!",
        submitFailed: "योजना संदर्भित करण्यात अयशस्वी!",
        submitting: "सबमिट करत आहे...",
        submit: "सबमिट करा",

        beneficiaryInformation: "लाभार्थी माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        date: "तारीख",

        selectSchemes: "योजना निवडा",
        schemes: "योजना",

        noSchemeName: "योजनेचे नाव नाही",
        noDescription: "वर्णन उपलब्ध नाही",
        requireDoc: "आवश्यक कागदपत्रे",
        noRequireDoc: "आवश्यक कागदपत्रे उपलब्ध नाहीत",
        eligibility: "पात्रता",
        noEligibility: "पात्रता निकष उपलब्ध नाहीत",
        coveredDiseases: "समाविष्ट रोग",
        noDiseasesListed: "कोणतेही रोग सूचीबद्ध नाहीत",

        remarks: "शेरा",
        remark: "टिप्पणी"
    }
};
